import * as React from 'react';
import useWidget from '@Utils/core/useWidget';
import { WidgetId } from '@Utils/edge/constants';

const useLoadRandomAvatar = () => {
  const widgetGeneratorGlobal = useWidget(WidgetId.GeneratorGlobalV3);
  const avatars = widgetGeneratorGlobal.repeaters.avatars;

  const random = Math.floor(Math.random() * avatars.length);

  const loadAvatar = React.useCallback(() => {
    return avatars[random];
  }, [avatars, random]);

  return {
    loadAvatar,
  };
};

export default useLoadRandomAvatar;
